import { render, staticRenderFns } from "./price-lock.vue?vue&type=template&id=46a1bdc6"
import script from "./price-lock.vue?vue&type=script&lang=js"
export * from "./price-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports